import { useState } from 'react';
import { PersonsV3 } from '@frontend/api-person';
import { ModalControlResponse } from '@frontend/design-system';
import { useGetInsuranceVerificationModal } from '../../hooks';
import { DateRangeOptionValue } from '../../utils/constants';

type VerifyInsuranceSidePanelContainerProps = {
  verifyInsuranceModalControl: ModalControlResponse;
  verificationMetricModalControl: ModalControlResponse;
  locationId: string;
  personId: string;
  shouldShowTuuthFairyReport?: boolean;
  hasVerificationError?: boolean;
};

const CACHE_TIME = 5 * 60 * 1000; // 5 minutes

export const VerifyInsuranceFormSidePanelContainer = ({
  personId,
  locationId,
  verifyInsuranceModalControl,
  verificationMetricModalControl,
  shouldShowTuuthFairyReport = false,
  hasVerificationError = false,
}: VerifyInsuranceSidePanelContainerProps) => {
  const [defaultDateRange, setDefaultDateRange] = useState<DateRangeOptionValue>('today');

  const { data: personData, isLoading: isLoadingPersonInfo } = PersonsV3.PersonQueries.useGetPersonLegacyQuery(
    {
      personId: personId ?? '',
      locationIds: [locationId ?? ''],
    },
    {
      enabled: !!personId && !!locationId,
      cacheTime: CACHE_TIME,
      staleTime: CACHE_TIME,
      select: (data) => PersonsV3.PersonHelpers.convertPersonV3ToPerson(data),
    }
  );

  const { Modal: VerificationModal } = useGetInsuranceVerificationModal({
    verifyInsuranceModalControl,
    verificationMetricModalControl,
    defaultDateRange,
    setDefaultDateRange,
    personInfo: personData,
    locationId,
    shouldShowTuuthFairyReport,
    hasVerificationError,
  });

  return !isLoadingPersonInfo && VerificationModal;
};
